<template lang="pug">
div
  ods-module(shadow="never")
    div(slot="header")
      span {{ $t('loyalty.selectTemplate', { pag: '1' })  }}
    div.text_item
      span {{ $t('loyalty.selectOneTemplate') }}
      filter-table(layout="text" @inputSearchFilter="inputSearchFilter")
      ods-table(
        v-loading="loadingTable"
        style='width: 100%'
        height="54vh"
        size="medium"
        highlight-current-row
        @current-change="selectRow"
        :data="tableDataRendered").sel
        ods-table-column(prop='NOMBRE' :label="$t('loyalty.name')" align="left")
          template(slot-scope="scope")
            div {{ scope.row.descripcion }}
        ods-table-column(prop='FECINI' :label="$t('loyalty.startDate')" align="center")
          template(slot-scope="scope")
            div {{ scope.row.fechaici | formatDateLocale }}
        ods-table-column(prop='FECFIN' :label="$t('loyalty.endDate')" align="center")
          template(slot-scope="scope")
            div {{ scope.row.fechafin | formatDateLocale }}
        ods-table-column(prop='IMPMIN' :label="$t('loyalty.minimumAmount')" align="right")
          template(slot-scope="scope")
            div {{ scope.row.imp_minimo }}
        ods-table-column(prop='MAXCUP' :label="$t('loyalty.maxCoupon')" align="right")
          template(slot-scope="scope")
            div {{ scope.row.num_max_cup }}
        ods-table-column(prop='CUPONESASIG' :label="$t('loyalty.couponsAssigned')" align="right")
          template(slot-scope="scope")
            div {{ scope.row.num_cup_act }}
        ods-table-column(align="right")
          template(slot-scope='scope')
            ods-button(type="text" size="mini" @click.native="verCupon(scope.row)" )
              div.actionsTicket
                img(:src="require('@/assets/icons/ticket.svg')" alt="Ticket")
                span {{ $t('loyalty.viewCoupon') }}
      div.footer
        paginator(v-if="tableDataRendered!==null"
          :isNextPage="paginationParams.indMasDatos"
          :currentPage="paginationParams.pantPagina"
          @buttonPrevAction="getData(false)"
          @buttonNextAction="getData(true)")
    coupon-preview(v-if="dialogVisible" :data="data")
</template>

<script>
import FilterTable from '@/components/shared/FilterTable'
import Paginator from '@/components/shared/Paginator'
import CouponPreview from '@/components/loyalty/Coupons/CouponPreview'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'PlantillasTableAssign',
  components: {
    Paginator,
    FilterTable,
    CouponPreview
  },
  data () {
    return {
      // estaba a true hasta que tenga datos
      loadingTable: false,
      data: {},
      tableDataRendered: this.datatable,
      tableData: this.datatable,
      paginationParams: {
        currentPage: 1,
        indMasDatos: 'N',
        claveInicio: 1,
        claveFin: 20
      },
      dialogVisible: false,
      rowSelected: null
    }
  },
  computed: {
    ...mapGetters({
      loadingProgram: 'getProgramState',
      appProgramTitle: 'getSelectedProgram'
    })
  },
  methods: {
    ...mapActions(['setCodPlantilla', 'getCLPCP', 'getTemplateDetails']),
    async getData (pagina) {
      let params = { ...this.paginationParams }
      if (typeof pagina !== 'undefined') {
        // console.log('paginando')
        params = pagina ? { ...this.params, ...this.paginationParams, avanzar: true } : { ...this.params, ...this.paginationParams, retroceder: true }
      }
      this.loadingTable = true
      this.getCLPCP(params).then(resData => {
        if (resData && resData.registros && resData.retorno === '000') {
          console.log(resData)
          this.tableData = Array.isArray(resData.registros) ? resData.registros : [resData.registros]
          this.tableDataRendered = this.tableData
          this.paginationParams = {
            pantPagina: resData.pantPagina,
            indMasDatos: resData.indMasDatos,
            claveInicio: resData.claveInicio,
            claveFin: resData.claveFin
          }
        } else {
          this.tableData = null
          this.tableDataRendered = this.tableData
        }
        this.loadingTable = false
      }).catch(err => {
        console.log('getCLPCP params error', params, err)
      })
    },
    inputSearchFilter (text) {
      // console.log('inputSearchFilter')
      this.tableDataRendered = this.tableData.filter(obj => Object.values(obj).some(val => val.toString().toLowerCase().indexOf(text.toLowerCase()) > -1))
    },
    selectRow (row) {
      // console.log('selectRow')
      // sessionStorage.setItem('Codplantilla', row.cod_plantilla)
      this.setCodPlantilla(row.cod_plantilla)
      this.dialogVisible = false
      this.rowSelected = row
      this.data = null
      this.$emit('row-selected', this.rowSelected)
    },
    async verCupon (row) {
      this.dialogVisible = false
      this.setCodPlantilla(row.cod_plantilla)
      if (row) {
        this.getTemplateDetails().then(response => {
          if (response && response.registros && response.retorno === '000') {
            console.log(response.registros)
            this.dialogVisible = true
            this.data = response
          } else {
            this.dialogVisible = false
            this.data = null
            this.$notify({
              title: 'ERROR en datos',
              message: `No hay datos válidos para ${row.descripcion}.`,
              type: 'error',
              offset: 50,
              duration: 5000
            })
          }
        })
      }
    }
  },
  watch: {
    async activarPlantillas (newVal, oldVal) {
      if (newVal) {
        // console.log('activarPlantillas')
        await this.getData()
      }
    }
  },
  async mounted () {
    // console.log('lomonta')
    this.getData()
  }
}
</script>

<style lang="scss">
.actionsTicket {
  min-width: 104px;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
}
.sel {
  cursor: pointer;
}
</style>
